<div class="mb-4 flex justify-end">
  <!--  <address-client-form-->
  <!--    (response)="responseForm($event)"-->
  <!--    [editItem]="item"-->
  <!--  ></address-client-form>-->
  <button mat-raised-button class="btn-add" (click)="addTariff()">
    Inserir
    <mat-icon>add</mat-icon>
  </button>
</div>
@if (itemsList.length > 0) {
  <div>
    <div class="tab-overflow">
      <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
        @for (column of columns; track column.keyColumn) {
          <ng-container matColumnDef="{{ column.keyColumn }}">
            <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
            <td mat-cell *matCellDef="let element">
              @if (column.keyColumn == 'action') {
                <div class="flex justify-center items-center gap-3">
                  @if (column.key.edit) {
                    <mat-icon
                      class="btn-icon-outline"
                      fontIcon="edit"
                      (click)="selectItemEvent(element)"
                    />
                  }
                  @if (column.key.delete) {
                    <mat-icon
                      class="btn-icon-outline"
                      fontIcon="delete"
                      (click)="deleteItemEvent(element)"
                    />
                  }
                </div>
              } @else if (column.keyColumn == 'location_OD') {
                <b>Origem: </b>{{ element.origem }}<br />
                <b>Destino: </b>{{ element.destino }}
              } @else if (column.keyColumn == 'servico_TS') {
                <b>Tipo: </b>{{ element.tipoServico }}<br />
                <b>Serviço: </b>{{ element.servico }}
              } @else if (column.keyColumn == 'vehicle_VM') {
                <b>Tipo veículo: </b>{{ element.tipoVeiculo }}<br />
                <b>Tipo motorista: </b>{{ element.tipoMotorista }}
              } @else if (column.keyColumn == 'custoExtra_HK') {
                <b>Hora: </b>{{ element.custoHoraExtra_formatado }}<br />
                <b>KM: </b>{{ element.custokmExtra_formatado }}
              } @else {
                {{ element[column.key] }}
              }
            </td>
          </ng-container>
        }
        <tr
          mat-header-row
          class="style-header"
          *matHeaderRowDef="displayedColumns"
        ></tr>
        <tr
          mat-row
          class="style-row"
          *matRowDef="let row; columns: displayedColumns"
        ></tr>
      </table>
    </div>
    <mat-paginator #paginator [pageSize]="5"> </mat-paginator>
  </div>
}

<!--<div>-->
<!--  <table-list-form-->
<!--    [dataSource]="itemsList"-->
<!--    [columns]="columns"-->
<!--    (selectItem)="editItem($event)"-->
<!--    (deleteItem)="deleteItem($event)"-->
<!--  />-->
<!--</div>-->
